import { IAlert } from "@components/core/Alerts";
import { Alert } from "@components/interface/Alert";
import React, { CSSProperties } from "react";
import { THEME } from "@components/core/theme";

const styles: Record<string, CSSProperties> = {
    title: {
        ...THEME.text,
        fontSize: "small",
        fontWeight: "bold",
        letterSpacing: 1,
        opacity: 0.7,
        textTransform: "uppercase"
    },
    name: {
        ...THEME.text,
        fontSize: "x-large",
        fontWeight: "bold",
        margin: "4px 0"
    },
    description: {
        ...THEME.text,
        fontSize: "medium"
    }
};

interface IAchievementAlert {
    alert: IAlert
    onClose: () => boolean
}

export function AchievementAlert({ alert, onClose }: IAchievementAlert) {
    return (
        <Alert onClose={onClose}>
            <div style={styles.title}>Achievement Unlocked</div>
            <div style={styles.name}>{alert.data.name}</div>
            <div style={styles.description}>{alert.data.description}</div>
        </Alert>
    );
}
